import { Navigate } from "react-router-dom";

export default function RequireAuth({ children }: { children: JSX.Element }) {
  const token = localStorage.getItem("token");

  if (!token) {
    // トークンがない場合はログインページにリダイレクト
    return <Navigate to="/auth/login" replace />;
  }

  return children;
}
